export const FOOD_CATEGORIES = [
  'Eggs', 'Fish', 'Salads', 'Bakery', 'Cakes', 'Stews', 'BBQ', 'Veggies',
  'Desserts', 'Breakfast', 'Chicken', 'Tofu', 'Soup', 'Beef', 'Turkey',
  'Cupcake', 'Potatoes', 'Cookies', 'Pies', 'Pasta', 'Seafood', 'Dressings',
  'Bread', 'Sweet pastries', 'Savoury pastries', 'Pork', 'Jam', 'Fruits',
  'Smoothies', 'Cheese',
];

export const AVOID_CATEGORIES = ['Nuts', 'Dairy', 'Gluten', 'Eggs'];

export const CLASSIFICATION_CATEGORIES = [
  'Vegan', 'Kosher', 'Keto', 'Low carbs', 'Vegetarian', 'Halal',
];

export const CATEGORY_ICONS = {
  Eggs: '🥚', Fish: '🐟', Salads: '🥗', Bakery: '🧁', Cakes: '🎂',
  Stews: '🍲', BBQ: '🔥', Veggies: '🥦', Desserts: '🍰', Breakfast: '🥞',
  Chicken: '🍗', Tofu: '🧊', Soup: '🥣', Beef: '🥩', Turkey: '🦃',
  Cupcake: '🧁', Potatoes: '🥔', Cookies: '🍪', Pies: '🥧', Pasta: '🍝',
  Seafood: '🦐', Dressings: '🫒', Bread: '🍞', 'Sweet pastries': '🥐',
  'Savoury pastries': '🥟', Pork: '🥓', Jam: '🍯', Fruits: '🍓',
  Smoothies: '🥤', Cheese: '🧀',
};
